import { TankBatterySetupTemplateBase } from './base/tank-battery-setup-template-base';

export class TankBatterySetupTemplate extends TankBatterySetupTemplateBase { }